export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '';
export const RECAPTCHA_BASE_WIDTH = 304;
export const RECAPTCHA_BASE_HEIGHT = 78;
export const isRecaptchaEnabled = RECAPTCHA_SITE_KEY.length > 0;
